// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const MetaGenerator = registerClientReference(
    function() { throw new Error("Attempted to call MetaGenerator() from the server but MetaGenerator is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/ai/_form.tsx",
    "MetaGenerator",
);
export const PromptStudio = registerClientReference(
    function() { throw new Error("Attempted to call PromptStudio() from the server but PromptStudio is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/ai/_form.tsx",
    "PromptStudio",
);
export const ProviderPing = registerClientReference(
    function() { throw new Error("Attempted to call ProviderPing() from the server but ProviderPing is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/ai/_form.tsx",
    "ProviderPing",
);
